<template>
    <div class="main">
        <div class="notice">
            <div class="title">绑定须知：</div>
            <div class="content">只支持储蓄卡或借记卡<span style="color: #3B72FF;">(支持银行：中国银行、农业银行、工 商银行、建设银行、邮政储蓄、招商银行、平安银行、中信银 行、兴业银行、浦发银行、广发银行、上海银行)</span>请勿向他人透露验证码，注意保护个人隐私 
            </div>
        </div>
        <div class="wrap">
            <div>
                <div class="bankInfo">
                    <span>请输入银行卡号</span>
                    <span class="label" style="color: #999999;">{{bankName}}</span>
                </div>

                <input type="text"
                       placeholder="请输入本人的银行卡号"
                       @input="inputChange"
                       class="inputStyle card"
                       v-model="bankCard">
            </div>


            <div class="pro_box">
                <span class="label">预留手机号</span>
                <input type="text"
                       placeholder="请输入银行绑定的预留手机号"
                       class="inputStyle"
                       v-model="phone" maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'')">
            </div>
            <div class="inputCode">
                <div class="pro_box" style="border-bottom: none;">
                    <span class="label">验证码</span>
                    <input type="text"
                           placeholder="请输入验证码"
                           class="inputStyle"
                           v-model="code" style="width: 100px;">
                </div>
                <div class="code" @click="sendCode">{{codeMsg1}}</div>
            </div>

        </div>
        <div class="xy">
            <div v-if="selected" class="img"><img src="@/assets/img/vip/selected.png" style="width: 100%;height: 100%;"
                                                  @click="selected=!selected"></div>
            <div v-else class="img"><img src="@/assets/img/vip/no_select.png" style="width: 100%;height: 100%;"
                                         @click="selected=!selected"></div>
            申请即代表阅读并同意<span style="color: #3B72FF;">《个人信息授权书》</span>
        </div>
        <div>
            <div class="btn" @click="verifyCard"><span>立即认证</span>
            </div>
        </div>

        <Loading :isShow="loading"></Loading>

    </div>
</template>

<script>
    import Loading from '@/components/loading';

    export default {
        components: {
            Loading
        },
        name: "shBankInfoAuth",
        data() {
            return {
                bankCard: "",
                bankName: "",
                phone: "",
                code: "",
                timer1: null,
                countdown1: 40,
                codeMsg1: "获取验证码",
                loading: false,
                selected: true,
                smsSerialNo: "",
            }
        }, created() {
            this.util.title("四要素绑卡");
        }, methods: {
            inputChange() {
                if (this.bankCard.trim().length != 6) {
                    return;
                }
                let param = {
                    bankCard: this.bankCard,
                };
                this.$get("/app/v1.0/payBank/getBankName", param)
                    .then((res) => {
                        if (res.code == 200) {
                            this.bankName = res.data;
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {

                    });

            }, sendCode() {
                if (!this.bankCard) {
                    this.util.toast({msg: "银行卡号不能为空"})
                    return;
                }
                if (!this.phone) {
                    this.util.toast({msg: "预留手机号不能为空"})
                    return;
                }

                this.loading = true;
                let param = {
                    cardNo: this.bankCard,
                    phone: this.phone
                }
                this.$post('/app/api/v1/showxin/bindCard', param)
                    .then(res => {
                        var e = res;
                        if (e.code == 200) {
                            this.loading = false;
                            this.smsSerialNo = e.data;
                            this.setTime1();
                            this.util.toast({msg: "发送成功"})
                        } else if (e.code == 2000) {
                            this.util.toast({msg: "已绑卡，请完成下一步人脸识别"})
                            this.$router.push({
                                path: "/vip/shFaceAuth",
                                query: {
                                    memberId: e.data
                                },
                            });
                        } else {
                            this.loading = false;
                            this.util.toast({msg: e.message})
                        }
                    })
                    .catch(error => {

                    });
            }, verifyCard() {
                if (!this.smsSerialNo) {
                    this.util.toast({msg: "smsSerialNo参数不能为空"})
                    return;
                }
                if (!this.code) {
                    this.util.toast({msg: "验证码不能为空"})
                    return;
                }
                if (!this.selected) {
                    this.util.toast({msg: "请勾选协议"})
                    return;
                }
                this.loading = true;
                let param = {
                    smsSerialNo: this.smsSerialNo,
                    smsCode: this.code
                }
                this.$post('/app/api/v1/showxin/verifyCard', param)
                    .then(res => {
                        var e = res;
                        if (e.code == 200) {
                            this.loading = false;
                            this.$router.push({
                                path: "/vip/shFaceAuth",
                                query: {
                                    memberId: e.data
                                },
                            });
                        } else if (e.code == 2000) {
                            this.util.toast({msg: "已绑卡，请完成下一步人脸识别"})
                            this.$router.push({
                                path: "/vip/shFaceAuth",
                                query: {
                                    memberId: e.data
                                },
                            });
                        } else {
                            this.loading = false;
                            this.isMember();
                        }
                    })
                    .catch(error => {

                    });
            }, isMember() {//查询是否是会员
                this.$get("/app/v1.0/memeber/isMember")
                    .then((res) => {
                        if (res.code == 200) {
                            var data = res.data;
                            if (data) {
                                this.$router.push({
                                    path: "/afterLoan/newApplySuccess",
                                    query: {
                                        status: 1
                                    },
                                });
                            } else {
                                this.$router.push({
                                    path: "/vip/choicePackage",
                                    query: {
                                        productId: 376,
                                        scenceCode: 4,
                                        webRefresh: 1
                                    },
                                });
                            }

                        } else {
                            this.util.toast({msg: res.message})
                        }
                    })
                    .catch((error) => {
                    });
            }, setTime1() {//倒计时1
                let _this = this;
                this.timer1 = setInterval(() => {
                    if (_this.countdown1 > 0 && _this.countdown1 <= 40) {
                        _this.countdown1--;
                        if (_this.countdown1 !== 0) {
                            _this.codeMsg1 = "重新发送(" + _this.countdown1 + ")";
                        } else {
                            clearInterval(_this.timer1);
                            _this.codeMsg1 = "获取验证码";
                            _this.countdown1 = 40;
                            _this.timer1 = null;
                        }
                    }
                }, 1000)
            }, closeTime1() {
                clearInterval(this.timer1);
                this.codeMsg1 = "获取验证码";
                this.countdown1 = 40;
                this.timer1 = null;
            }


        }
    }
</script>

<style scoped>
    .main {
        background: #F7F7F7;
    }

    .wrap {
        margin: 0.12rem 0.15rem 0.1rem 0.15rem;
        padding: 0.11rem 0.1rem 0.15rem 0.15rem;
        background: #FFFFFF;
        border-radius: 0.08rem;
    }

    .wrap .bankInfo {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.1rem;
    }

    .notice {
        margin: 0.12rem 0.15rem 0.1rem 0.15rem;
        padding: 0.11rem 0.1rem 0.15rem 0.15rem;
        font-size: 0.12rem;
        background: #E8F0FF;
        border-radius: 0.08rem;
    }

    .notice .title {
        font-size: 0.16rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-bottom: 0.05rem;
    }

    .notice .content {
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }

    .pro_box {
        clear: both;
        overflow: hidden;
        border-bottom: 1px solid #eee;
        background: #fff;
    }

    .label {
        width: 0.75rem;
        font-family: PingFangSC-Regular, PingFang SC;
        display: inline-block;
        font-size: 0.14rem;
        font-weight: 400;
        color: #333333;
    }

    .inputStyle {
        width: 70%;
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
        padding: 0.15rem;
    }

    .card {
        border-radius: 4px;
        border: 1px solid #979797;
        width: 100%;
    }

    .btn {
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        box-shadow: 0rem 0.06rem 0.1rem 0rem #E4EEFA;
        color: #fff;
        border-radius: 0.25rem;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.17rem;
        text-align: center;
        line-height: 0.5rem;
        width: 95%;
        margin: 0 auto;
        margin-bottom: 0.1rem;
    }

    .btn span {
        font-size: 0.17rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
    }

    .desc .content {
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    input::-webkit-input-placeholder {
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .inputCode {
        display: flex;
        justify-content: space-between;
    }

    .inputCode .code {
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #527AF5;
        line-height: 50px;
        margin-right: 20px;
    }

    .xy {
        display: flex;
        padding: 0.11rem 0.1rem 0.15rem 0.15rem;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .xy .img {
        width: 0.12rem;
        height: 0.12rem;
        margin-right: 4px;
        margin-top: 1px;
    }


</style>
